import React from 'react';
import PropTypes from 'prop-types';
import {ITEM_TYPE} from 'am-constants';
import Avatar from 'components/Avatar';
import getInitials from 'utils/getInitials';
import AvatarList from 'components/AvatarList';

ContentReviewerCellContent.propTypes = {
  itemId: PropTypes.number,
  itemTypeId: PropTypes.number.isRequired,
  reviewers: PropTypes.arrayOf(PropTypes.shape({})),
};

const PAGE_ITEM_TYPES = [
  ITEM_TYPE.CHECKLIST,
  ITEM_TYPE.DOCUMENT,
  ITEM_TYPE.FORM,
];

function ContentReviewerCellContent (props) {
  const {
    itemId,
    itemTypeId,
    reviewers,
  } = props;

  if (!itemId) {
    return null;
  }

  if (!PAGE_ITEM_TYPES.includes(itemTypeId)) {
    return null;
  }

  return (
    <AvatarList>
      {reviewers.map((reviewer) => (
        <Avatar key={reviewer.id}>{getInitials(reviewer.name)}</Avatar>
      ))}
    </AvatarList>
  );
}

export default ContentReviewerCellContent;
